// actions/employee-onboarding/skip.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function skipHasErrored(bool) {
  return {
    type: 'ONBOARDING_SKIP_HAS_ERRORED',
    hasErrored: bool
  };
}

export function skipIsLoading(bool) {
  return {
    type: 'ONBOARDING_SKIP_IS_LOADING',
    isLoading: bool
  };
}

export function skipFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_SKIP_FETCH_DATA_SUCCESS',
    data
  };
}

export function skipFetchData(host, params) {
  return (dispatch) => {
    dispatch(skipIsLoading(true));
    dispatch(skipHasErrored(false));
    fetch(host + 'admin/skip', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(skipFetchDataSuccess(result));
            dispatch(skipHasErrored(false));
            dispatch(skipIsLoading(false));
            PubSub.publish('employee.add.action', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(skipHasErrored(true));
            dispatch(skipIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(skipHasErrored(true));
      dispatch(skipIsLoading(false));
    });
  };
}